import React, { ComponentProps } from 'react';
import styled from 'styled-components';
import { Poppins } from './Poppins';
import { Tooltip } from './Tooltip';

const StyledInputLabel = styled(Poppins).attrs((p) => {
  return { px: 14, ...p };
})`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.cflowerBlue};
  display: block;
`;

const LabelRow = styled.div`
  display: flex;
  gap: 4px;
`;

type InputLabelProps = Omit<ComponentProps<typeof Poppins>, 'ref'> & {
  children: React.ReactNode;
  tooltip?: string;
};

export const InputLabel: React.FC<InputLabelProps> = ({ children, tooltip, ...poppinsProps }) => {
  if (tooltip) {
    return (
      <LabelRow>
        <StyledInputLabel {...poppinsProps}>{children}</StyledInputLabel>
        <Tooltip infoIconStyle={{ transform: 'scale(0.7)', marginTop: '-6px' }} place="right" dataHtml={tooltip} />
      </LabelRow>
    );
  }

  return <StyledInputLabel {...poppinsProps}>{children}</StyledInputLabel>;
};
